import React from 'react';
import downloadIcon from 'clientRequirements/images/download_Icon.png';
import { Loader } from '../../../ui-library';
import './CellPDFViewIcon.css';

interface CellPDFViewIconProps {
    value?: string;
    onDownload?: (id?: string | number, contactId?: string | number) => void;
    inProgress?: boolean;
    // Consolidating the second argument items into props
    id?: string | number;
    contactId?: string | number;
}

const CellPDFViewIcon: React.FC<CellPDFViewIconProps> = ({
    value = '',
    onDownload = () => {},
    inProgress = false,
    id,
    contactId,
}) => {
    // Return null if value is undefined or explicitly null
    if (value === undefined || value === null) return null;

    const handleClick = () => {
        if (!inProgress && onDownload) {
            onDownload(id, contactId);
        }
    };

    return (
        <button
            type="button"
            role="link"
            className="table-cell_linked cell-pdf-view"
            onClick={handleClick}
            disabled={inProgress} // Good practice to disable the button during progress
        >
            {inProgress ? (
                <Loader />
            ) : (
                <img
                    width="18"
                    height="18"
                    src={downloadIcon}
                    alt="Download PDF"
                />
            )}
        </button>
    );
};

export default CellPDFViewIcon;
